import React from 'react';
import { Box, Typography, Paper, Button, Chip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { colors } from '../../theme/colorTokens';

/**
 * Top-N editorial shortlist (e.g. "Respuesta rápida" section).
 * @param {{ title: string, items: Array<{ badge: string, name: string, detail: string, cta: string, link: string, external?: boolean }> }} props
 */
const Shortlist = ({ title, items }) => (
  <Box sx={{ mb: { xs: 3, md: 4 } }}>
    <Typography
      variant="h5"
      component="h2"
      sx={{ fontWeight: 700, fontSize: { xs: '20px', md: '24px' }, color: colors.textPrimary, mb: 2 }}
    >
      {title}
    </Typography>
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: `repeat(${Math.min(items.length, 3)}, 1fr)` }, gap: 2 }}>
      {items.map((item, i) => (
        <Paper
          key={i}
          elevation={0}
          sx={{
            border: `1px solid ${colors.border}`,
            borderRadius: '14px',
            p: { xs: 2.5, md: 3 },
            display: 'flex',
            flexDirection: 'column',
            transition: 'all 200ms ease',
            '&:hover': { borderColor: colors.primary, boxShadow: '0 4px 16px rgba(0,0,0,0.06)' },
          }}
        >
          <Chip
            label={item.badge}
            size="small"
            sx={{
              alignSelf: 'flex-start',
              mb: 1.5,
              bgcolor: i === 0 ? colors.primary : 'rgba(30,58,95,0.08)',
              color: i === 0 ? '#fff' : colors.primary,
              fontWeight: 600,
              fontSize: '12px',
              height: 24,
            }}
          />
          <Typography sx={{ fontWeight: 600, fontSize: '16px', color: colors.textPrimary, mb: 0.5 }}>
            {item.name}
          </Typography>
          <Typography sx={{ fontSize: '14px', color: colors.textSecondary, lineHeight: 1.6, mb: 2, flex: 1 }}>
            {item.detail}
          </Typography>
          <Button
            variant={i === 0 ? 'contained' : 'outlined'}
            disableElevation
            endIcon={<ArrowForwardIcon />}
            {...(item.external
              ? { component: 'a', href: item.link, target: '_blank', rel: 'noopener noreferrer' }
              : { href: item.link })}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              borderRadius: '10px',
              alignSelf: 'flex-start',
              ...(i === 0
                ? { bgcolor: colors.primary, '&:hover': { bgcolor: '#1A3152' } }
                : { borderColor: colors.border, color: colors.primary, '&:hover': { borderColor: colors.primary } }),
            }}
          >
            {item.cta}
          </Button>
        </Paper>
      ))}
    </Box>
  </Box>
);

export default Shortlist;
